module.exports = __webpack_public_path__ + "static/media/S3N12.22700702.svg";